import { type Dispatch, type FC, type SetStateAction } from 'react'

import {
  userSubOrderAccessorGetSubOrdersDocumentsWithSubOrderId,
  userSubOrderAccessorIsProductErx,
} from '../../../../order'
import { type SubOrderProductListProps } from '../../../hooks/useDirectContactFormOrderSelection'
import { useDirectFormDialogContext } from '../DirectContactFormDialogContext'

import { DirectContactFormOrderItemCheckboxSelection } from './DirectContactFormOrderItemCheckboxSelection'

export const DirectContactFormOrderItemsCheckboxSelection: FC<{
  selectedSubOrderItems: SubOrderProductListProps[]
  setSelectedSubOrderItems: Dispatch<SetStateAction<SubOrderProductListProps[]>>
}> = ({ selectedSubOrderItems, setSelectedSubOrderItems }) => {
  const { selectedOrder } = useDirectFormDialogContext()

  if (!selectedOrder) {
    return null
  }

  const productInfo =
    userSubOrderAccessorGetSubOrdersDocumentsWithSubOrderId(selectedOrder)

  if (productInfo.length === 0) {
    return null
  }

  return (
    <>
      {productInfo.map((item) => {
        if (!item.itemName || !item.pzn) {
          return null
        }

        const isERx = userSubOrderAccessorIsProductErx(item)

        return (
          <DirectContactFormOrderItemCheckboxSelection
            itemName={item.itemName}
            key={isERx ? item.hashedToken : item.offerId}
            selectedSubOrderItems={selectedSubOrderItems}
            setSelectedSubOrderItems={setSelectedSubOrderItems}
            {...item}
          />
        )
      })}
    </>
  )
}
